// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__22Snb","alert":"SettungsInbox_alert__1B3xd"};